import { PaymentMethodColumn as PaymentMethodColumnShared } from "@circle-react-shared/Paywalls/PaymentMethodColumn";

export const PaymentMethodColumn = (cellContext: any) => {
  const {
    row: { original: charge },
  } = cellContext;

  return <PaymentMethodColumnShared charge={charge} />;
};
